// Get The Look - Tabs + Scroll Carousel with Arrow Navigation
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.gtl-section');
  if (!section) return;

  // --- Tab Switching ---
  var tabs = section.querySelectorAll('.gtl-tab');
  var panels = section.querySelectorAll('.gtl-tab-panel');
  var panelArrowUpdaters = {};

  // Helper: append ?tab=<label> to View More links inside a panel
  function updateViewMoreLinks(panel, tabLabel) {
    var links = panel.querySelectorAll('.gtl-card__view-more-slide, .gtl-section__view-more-btn');
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      var url = new URL(href, window.location.origin);
      url.searchParams.set('tab', tabLabel.trim().toLowerCase());
      link.setAttribute('href', url.pathname + url.search);
    });
  }

  // Wire up hotspots inside each panel
  function initHotspots(panel) {
    var cards = panel.querySelectorAll('.gtl-card');
    cards.forEach(function (card) {
      var slider = card.querySelector('.gtl-products-slider');
      if (!slider) return;

      var productCards = slider.querySelectorAll('.gtl-product-card');
      var hotspots = card.querySelectorAll('.gtl-hotspot');

      hotspots.forEach(function (hotspot) {
        hotspot.addEventListener('click', function (e) {
          e.preventDefault();
          var slideIndex = parseInt(hotspot.getAttribute('data-slide-index'), 10);
          if (!isNaN(slideIndex) && productCards[slideIndex]) {
            productCards[slideIndex].scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            });

            hotspots.forEach(function (h) { h.classList.remove('is-active'); });
            hotspot.classList.add('is-active');
          }
        });
      });
    });
  }

  // --- Arrow Navigation ---
function initArrows(panel) {
  var wrapper = panel.querySelector('.gtl-section__slider-wrapper');
  var carousel = panel.querySelector('.gtl-section__carousel');
  if (!wrapper || !carousel) return;

  var prevBtn = document.createElement('button');
  prevBtn.type = 'button';
  prevBtn.className = 'gtl-arrow gtl-arrow--prev';
  prevBtn.setAttribute('aria-label', 'Previous');
  prevBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 19l-7-7 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var nextBtn = document.createElement('button');
  nextBtn.type = 'button';
  nextBtn.className = 'gtl-arrow gtl-arrow--next';
  nextBtn.setAttribute('aria-label', 'Next');
  nextBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  wrapper.appendChild(prevBtn);
  wrapper.appendChild(nextBtn);

  // Track intended scroll position to prevent overshoot on rapid clicks
  var targetScrollLeft = 0;

  function getScrollAmount() {
    var firstCard = carousel.querySelector('.carousel__slide');
    if (!firstCard) return 300;
    var style = window.getComputedStyle(carousel);
    var gap = parseInt(style.gap) || 20;
    return firstCard.offsetWidth + gap;
  }

  function getMaxScroll() {
    return carousel.scrollWidth - carousel.clientWidth;
  }

  // Use Math.round() to handle iOS subpixel float values
  function updateArrows() {
    var scrollLeft = Math.round(carousel.scrollLeft);
    var maxScroll = Math.round(getMaxScroll());

    prevBtn.classList.toggle('gtl-arrow--hidden', scrollLeft <= 0);
    nextBtn.classList.toggle('gtl-arrow--hidden', scrollLeft >= maxScroll);
  }

  prevBtn.addEventListener('click', function () {
    var maxScroll = getMaxScroll();
    // Sync target with actual position first, then step back
    targetScrollLeft = Math.round(carousel.scrollLeft) - getScrollAmount();
    targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll)); // clamp
    carousel.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function () {
    var maxScroll = getMaxScroll();
    // Sync target with actual position first, then step forward
    targetScrollLeft = Math.round(carousel.scrollLeft) + getScrollAmount();
    targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll)); // clamp
    carousel.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
  });

  carousel.addEventListener('scroll', updateArrows);

  var tabKey = panel.getAttribute('data-tab-panel');
  panelArrowUpdaters[tabKey] = updateArrows;

  if (panel.classList.contains('is-active')) {
    updateArrows();
  }
}

  // Tab click handler
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var targetTab = tab.getAttribute('data-tab');
      var tabLabel = tab.textContent;

      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');

      panels.forEach(function (p) { p.classList.remove('is-active'); });
      var targetPanel = section.querySelector('[data-tab-panel="' + targetTab + '"]');
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        updateViewMoreLinks(targetPanel, tabLabel);

        // Re-check arrow visibility now that the panel is visible
        if (panelArrowUpdaters[targetTab]) {
          panelArrowUpdaters[targetTab]();
        }
      }
    });
  });

  // Initialize all panels
  panels.forEach(function (panel) {
    initHotspots(panel);
    initArrows(panel);
  });

  var activePanel = section.querySelector('.gtl-tab-panel.is-active');
  if (activePanel) {
    var activeTab = section.querySelector('.gtl-tab.is-active');
    if (activeTab) {
      updateViewMoreLinks(activePanel, activeTab.textContent);
    }
  }
});
